/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { compose, withReducer, renderComponent, withHandlers, mapProps, branch } from 'recompose';
import LandingPageSpinner from '../Spinners/LandingPageSpinner.js';

export const FILTER = '@@list/FILTER';

export const initialState = {
  filterState: '',
  buckets: [],
  bucketStates: [],
};

const reducer = (state=initialState, action) => {
  switch (action.type) {
    case FILTER: {
      return {
        ...state,
        filterState: action.filterState
      };
    }
    default: {
      return state;
    }
  }
};

const connect = (columns, buckets, filter, sort) => compose(
  branch(
    (props) => !Boolean(props.rows),
    renderComponent(LandingPageSpinner)
  ),
  withReducer('bucketedList', 'dispatch',
    reducer,
    (props) => ({
      filterState: '',
      bucketStates: buckets.map((b) => b.open || false)
    })
  ),
  withHandlers(() => ({
    filter: ({ dispatch }) => (filterState) => dispatch({
      type: FILTER,
      //name,
      filterState,
    }),
  })),
  mapProps(
    (props) => {
      const filteredRows = props.rows.filter((row) => filter(row, props.bucketedList.filterState));
      //filteredRows.sort(sort);
      return {
        bucketedList: {
          actions: {
            filter: props.filter,
          },
          buckets: buckets.map((bucket, i) => {
            const _rows = bucket.partition(filteredRows);
            const _title = bucket.title(_rows);
            return {
              rows: _rows,
              title: _title,
              open: props.bucketedList.bucketStates[i],
              toggle: () => props.toggle(i)
            };
          }),
          columns,
        }
      };
    }
  )
);


export default connect;
